
<script>
export default {
    name: "object-image",
    props: {
        image: {
            type: Object,
            required: true
        }
    },
    mounted() {
    },
}
</script>

<template>
    <picture>
        <img :src="image.source_url" :alt="image.alt_text">
    </picture>
</template>

<style scoped lang="scss">

</style>
